import { Injectable } from '@angular/core'

interface FbqFunction {
    (...args: unknown[]): void
    callMethod?: (...args: unknown[]) => void
    queue?: unknown[]
    push?: unknown
    loaded?: boolean
    version?: string
}

declare global {
    interface Window {
        fbq?: FbqFunction
        _fbq?: FbqFunction
    }
}

const META_PIXEL_SRC = 'https://connect.facebook.net/en_US/fbevents.js'

@Injectable({
    providedIn: 'root',
})
export class MetaPixelService {
    private configuredPixelId: string | null = null
    private initialisedPixelId: string | null = null

    configure(pixelId: string | null): void {
        this.configuredPixelId = pixelId || null
    }

    trackSchedule(payload: { bookingId: string; reasonName: string | null }): void {
        const pixelId = this.configuredPixelId
        if (!pixelId) {
            return
        }
        this.injectBaseScript()
        const fbq = window.fbq
        if (!fbq) {
            return
        }
        if (this.initialisedPixelId !== pixelId) {
            fbq('init', pixelId)
            this.initialisedPixelId = pixelId
        }
        fbq('track', 'Schedule', {
            content_name: payload.reasonName || 'Booking',
            content_category: 'Booking',
            content_ids: [payload.bookingId],
        })
    }

    private injectBaseScript(): void {
        if (window.fbq) {
            return
        }
        const fbq: FbqFunction = function (...args: unknown[]) {
            if (fbq.callMethod) {
                fbq.callMethod(...args)
            } else {
                fbq.queue?.push(args)
            }
        }
        fbq.push = fbq
        fbq.loaded = true
        fbq.version = '2.0'
        fbq.queue = []
        window.fbq = fbq
        if (!window._fbq) {
            window._fbq = fbq
        }
        const script = document.createElement('script')
        script.async = true
        script.src = META_PIXEL_SRC
        const firstScript = document.getElementsByTagName('script')[0]
        firstScript?.parentNode?.insertBefore(script, firstScript)
    }
}
